import { Component } from '@angular/core';
import {
  FieldArrayType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';

export interface RepeaterAccordionFieldProps extends FormlyFieldProps {
  addText?: string;
  removeText?: string;
  removeAllText?: string;
  addClick?: any;
  labelHeader?: string;
  // Se presente sostituisce "labelHeader + numero" come titolo dell'elemento
  headerText?: (item: FormlyFieldConfig, index: number) => string;
  headerBtnLabel?: string;
  editable?: boolean;
}

@Component({
  selector: 'repeater--accordion-field',
  standalone: true,
  imports: [
    ...FORM_IMPORTS,
    ButtonModule,
    DividerModule,
    Accordion,
    AccordionPanel,
    AccordionContent,
    AccordionHeader,
  ],
  template: `
    <div class="flex flex-col gap-2 w-full">
      @if (props.label) {
        <legend>{{ props.label }}</legend>
      }
      @if (props.description) {
        <p>{{ props.description }}</p>
      }
      <p-accordion value="0" class="w-full">
        @for (
          field of field.fieldGroup;
          track field;
          let i = $index;
          let last = $last
        ) {
          <p-accordion-panel [value]="i">
            <p-accordion-header>
              <div class="w-full flex justify-between items-center pr-2">
                <span
                  class="{{
                    !isValid(field)
                      ? 'text-[var(--p-form-field-invalid-placeholder-color)] italic'
                      : ''
                  }}"
                  >{{
                    props.headerText
                      ? props.headerText(field, i)
                      : props.labelHeader + ' ' + (i + 1)
                  }}</span
                >
                <small
                  class="text-[var(--p-form-field-invalid-placeholder-color)] italic"
                >
                  <formly-validation-message
                    class="ui-message-text"
                    [field]="field"
                  ></formly-validation-message>
                </small>
                @if (props.editable ?? true) {
                  <p-button
                    type="button"
                    size="small"
                    severity="danger"
                    class="self-end z-50"
                    [variant]="'outlined'"
                    (click)="remove(i)"
                  >
                    {{ props.removeText }}
                  </p-button>
                }
              </div>
            </p-accordion-header>
            <p-accordion-content class="p-0">
              <formly-field [field]="field"></formly-field>
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>

      @if (props.editable ?? true) {
        <div class="flex gap-2 mt-4">
          <p-button
            type="button"
            size="small"
            variant="outlined"
            severity="secondary"
            (click)="callback()"
          >
            {{ props.addText }}
          </p-button>
          @if (props.removeAllText && field.fieldGroup?.length) {
            <p-button
              type="button"
              size="small"
              variant="outlined"
              severity="danger"
              (click)="removeAll()"
            >
              {{ props.removeAllText }}
            </p-button>
          }
        </div>
      }
      <p-divider />
    </div>
  `,
})
export class RepeaterAccordionFieldType extends FieldArrayType<
  FieldTypeConfig<RepeaterAccordionFieldProps>
> {
  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.valid;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }

  removeAll(): void {
    // Dall'ultimo al primo, così gli indici restano validi durante la rimozione
    for (let i = (this.field.fieldGroup?.length ?? 0) - 1; i >= 0; i--) {
      this.remove(i);
    }
  }

  callback() {
    this.add(this.formControl.value.length, []);

    setTimeout(() => {
      if (this.props.addClick) {
        this.props.addClick(this);
      }
    });
  }
}
